import { createClient } from "@supabase/supabase-js";

const supabaseUrl = import.meta.env.VITE_PUBLIC_SUPABASE_URL as string;
const supabaseAnonKey = import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY as string;

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

export type Installer = {
  id: string;
  company: string;
  contact: string;
  email: string;
  phone: string;
  service_states: string[];
  service_zips: string[];
  min_lead_score: number;
  contract_signed: boolean;
  signed_at: string | null;
  contract_ip: string | null;
  stripe_customer_id: string | null;
  stripe_payment_method_id: string | null;
  role: "installer" | "admin";
  created_at: string;
};
